module.exports = __webpack_public_path__ + "source/img/robot-think.48858f2b.png";